import { useQuery } from "@tanstack/react-query";

import { appointmentExchangesApi } from "@/api";
import { withLocalErrorHandling } from "@/api/middleware/errorMiddleware";
import { QueryKey } from "@/query/Query";

/**
 * One own Tauschanfrage with its offers, for the "Angebote zur Tauschanfrage" overlay. Nested under
 * the exchanges query key on purpose: every exchange mutation invalidates that prefix, so the overlay
 * refreshes after an accept, reject or withdrawal without the mutation knowing about it. Errors are
 * handled by the overlay itself — deleting the Anfrage from its footer invalidates this query while
 * it is still mounted, and the resulting 404 must not surface as a global toast.
 */
export function useExchangeDetailQuery(exchangeId: string) {
  const { data, isLoading, isError } = useQuery({
    queryKey: [QueryKey.AppointmentExchanges, "detail", exchangeId],
    queryFn: () => appointmentExchangesApi.getAppointmentExchange({ id: exchangeId }, withLocalErrorHandling),
  });

  return { detail: data, isLoading, isError };
}
